module.exports = __webpack_public_path__ + "img/3_dp.97944932.png";